/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Header_Fulldownload1Inputs */

const id_builds_header_fulldownload1 = /** @type {(inputs: Builds_Header_Fulldownload1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukuran unduhan penuh`)
};

const ms_builds_header_fulldownload1 = /** @type {(inputs: Builds_Header_Fulldownload1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saiz muat turun penuh`)
};

const da_builds_header_fulldownload1 = /** @type {(inputs: Builds_Header_Fulldownload1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuld downloadstørrelse`)
};

const de_builds_header_fulldownload1 = /** @type {(inputs: Builds_Header_Fulldownload1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vollständige Downloadgröße`)
};

const en_us2_builds_header_fulldownload1 = /** @type {(inputs: Builds_Header_Fulldownload1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full download size`)
};

const es_es2_builds_header_fulldownload1 = /** @type {(inputs: Builds_Header_Fulldownload1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamaño de descarga completa`)
};

const es_mx2_builds_header_fulldownload1 = /** @type {(inputs: Builds_Header_Fulldownload1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamaño de descarga completa`)
};

const fil_builds_header_fulldownload1 = /** @type {(inputs: Builds_Header_Fulldownload1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buong laki ng download`)
};

const fr_builds_header_fulldownload1 = /** @type {(inputs: Builds_Header_Fulldownload1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taille du téléchargement complet`)
};

const it_builds_header_fulldownload1 = /** @type {(inputs: Builds_Header_Fulldownload1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimensione del download completo`)
};

const hu_builds_header_fulldownload1 = /** @type {(inputs: Builds_Header_Fulldownload1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teljes letöltési méret`)
};

const nl_builds_header_fulldownload1 = /** @type {(inputs: Builds_Header_Fulldownload1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volledige downloadgrootte`)
};

const no_builds_header_fulldownload1 = /** @type {(inputs: Builds_Header_Fulldownload1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full nedlastingsstørrelse`)
};

const pl_builds_header_fulldownload1 = /** @type {(inputs: Builds_Header_Fulldownload1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pełny rozmiar pobierania`)
};

const pt_br2_builds_header_fulldownload1 = /** @type {(inputs: Builds_Header_Fulldownload1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamanho do download completo`)
};

const pt_builds_header_fulldownload1 = /** @type {(inputs: Builds_Header_Fulldownload1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamanho da transferência completa`)
};

const ro_builds_header_fulldownload1 = /** @type {(inputs: Builds_Header_Fulldownload1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimensiunea descărcării complete`)
};

const fi_builds_header_fulldownload1 = /** @type {(inputs: Builds_Header_Fulldownload1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Täyden latauksen koko`)
};

const sv_builds_header_fulldownload1 = /** @type {(inputs: Builds_Header_Fulldownload1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fullständig nedladdningsstorlek`)
};

const vi_builds_header_fulldownload1 = /** @type {(inputs: Builds_Header_Fulldownload1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kích thước tải xuống đầy đủ`)
};

const tr_builds_header_fulldownload1 = /** @type {(inputs: Builds_Header_Fulldownload1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tam indirme boyutu`)
};

const cs_builds_header_fulldownload1 = /** @type {(inputs: Builds_Header_Fulldownload1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velikost úplného stažení`)
};

const bg_builds_header_fulldownload1 = /** @type {(inputs: Builds_Header_Fulldownload1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пълен размер за изтегляне`)
};

const ru_builds_header_fulldownload1 = /** @type {(inputs: Builds_Header_Fulldownload1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Полный размер загрузки`)
};

const uk_builds_header_fulldownload1 = /** @type {(inputs: Builds_Header_Fulldownload1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Повний розмір завантаження`)
};

const ar_builds_header_fulldownload1 = /** @type {(inputs: Builds_Header_Fulldownload1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حجم التنزيل الكامل`)
};

const hi_builds_header_fulldownload1 = /** @type {(inputs: Builds_Header_Fulldownload1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूर्ण डाउनलोड आकार`)
};

const th_builds_header_fulldownload1 = /** @type {(inputs: Builds_Header_Fulldownload1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ขนาดดาวน์โหลดทั้งหมด`)
};

const ja_builds_header_fulldownload1 = /** @type {(inputs: Builds_Header_Fulldownload1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完全ダウンロードサイズ`)
};

const zh_cn2_builds_header_fulldownload1 = /** @type {(inputs: Builds_Header_Fulldownload1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完整下载大小`)
};

const zh_hant1_builds_header_fulldownload1 = /** @type {(inputs: Builds_Header_Fulldownload1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完整下載大小`)
};

const ko_builds_header_fulldownload1 = /** @type {(inputs: Builds_Header_Fulldownload1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전체 다운로드 크기`)
};

/**
* | output |
* | --- |
* | "Full download size" |
*
* @param {Builds_Header_Fulldownload1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_header_fulldownload1 = /** @type {((inputs?: Builds_Header_Fulldownload1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Header_Fulldownload1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_header_fulldownload1(inputs)
	if (locale === "ms") return ms_builds_header_fulldownload1(inputs)
	if (locale === "da") return da_builds_header_fulldownload1(inputs)
	if (locale === "de") return de_builds_header_fulldownload1(inputs)
	if (locale === "en-US") return en_us2_builds_header_fulldownload1(inputs)
	if (locale === "es-ES") return es_es2_builds_header_fulldownload1(inputs)
	if (locale === "es-MX") return es_mx2_builds_header_fulldownload1(inputs)
	if (locale === "fil") return fil_builds_header_fulldownload1(inputs)
	if (locale === "fr") return fr_builds_header_fulldownload1(inputs)
	if (locale === "it") return it_builds_header_fulldownload1(inputs)
	if (locale === "hu") return hu_builds_header_fulldownload1(inputs)
	if (locale === "nl") return nl_builds_header_fulldownload1(inputs)
	if (locale === "no") return no_builds_header_fulldownload1(inputs)
	if (locale === "pl") return pl_builds_header_fulldownload1(inputs)
	if (locale === "pt-BR") return pt_br2_builds_header_fulldownload1(inputs)
	if (locale === "pt") return pt_builds_header_fulldownload1(inputs)
	if (locale === "ro") return ro_builds_header_fulldownload1(inputs)
	if (locale === "fi") return fi_builds_header_fulldownload1(inputs)
	if (locale === "sv") return sv_builds_header_fulldownload1(inputs)
	if (locale === "vi") return vi_builds_header_fulldownload1(inputs)
	if (locale === "tr") return tr_builds_header_fulldownload1(inputs)
	if (locale === "cs") return cs_builds_header_fulldownload1(inputs)
	if (locale === "bg") return bg_builds_header_fulldownload1(inputs)
	if (locale === "ru") return ru_builds_header_fulldownload1(inputs)
	if (locale === "uk") return uk_builds_header_fulldownload1(inputs)
	if (locale === "ar") return ar_builds_header_fulldownload1(inputs)
	if (locale === "hi") return hi_builds_header_fulldownload1(inputs)
	if (locale === "th") return th_builds_header_fulldownload1(inputs)
	if (locale === "ja") return ja_builds_header_fulldownload1(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_header_fulldownload1(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_header_fulldownload1(inputs)
	return ko_builds_header_fulldownload1(inputs)
});
export { builds_header_fulldownload1 as "builds.header.fullDownload" }